module.exports = __webpack_public_path__ + "static/img/color.309eade2.jpg";